import EventEmitter from 'eventemitter3';

import { type SocketInterface, type YjsSocketEvents } from './socket.ts';

export class NoopTestSocket
  extends EventEmitter<YjsSocketEvents>
  implements SocketInterface
{
  send(): void {}
  sendToPeer(): void {}
  sendAwareness(): void {}
  clearPendingMessages(): void {}
  skipGracePeriod(): void {}
  restart(): void {}
  resetReconnectBackoff(): void {}
  destroy(): void {}
  pause(): void {}
  resume(): void {}
  async connect(): Promise<void> {}
  flushTransport(_ignoreAck?: boolean): void {}
  getTransport(): void {}
  open = false;
  state = 'init' as const;
  collabInfrastructure = undefined;
}
